<div class="container">
  <h1>Bug Reports</h1>
  
  <table mat-table [dataSource]="reports" multiTemplateDataRows class="mat-elevation-z8">
    
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> ID </th>
      <td mat-cell *matCellDef="let element"> {{element.id}} </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> User </th>
      <td mat-cell *matCellDef="let element"> 
        {{element.username || 'Guest'}} 
        @if(element.vrchat_username) {
          ({{element.vrchat_username}})
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="ip">
      <th mat-header-cell *matHeaderCellDef> IP </th>
      <td mat-cell *matCellDef="let element"> {{element.ip_address}} </td>
    </ng-container>

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef> Date </th>
      <td mat-cell *matCellDef="let element"> {{element.created_at | date:'medium'}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="element.expanded = !element.expanded">
          <mat-icon>{{element.expanded ? 'expand_less' : 'expand_more'}}</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div class="element-detail">
          @if (element.expanded) {
            <div class="detail-content">
              <pre>{{ formatErrors(element.errors) }}</pre>
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;"
        class="element-row"
        [class.expanded-row]="element.expanded">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>
</div>
